import React from "react";
import { FormattedMessage } from "react-intl";
import { Badge } from "@chakra-ui/react";

/**
 * Component for displaying a default payment method tag.
 * @returns {JSX.Element} DefaultText component.
 */
const DefaultText = () => {
  return (
    <Badge p="1" mx="1" data-testid="default-payment-method">
      <FormattedMessage defaultMessage="Default" description="label" />
    </Badge>
  );
};

/**
 * Component for displaying an expired payment method tag.
 * @returns {JSX.Element} ExpiredText component.
 */
const ExpiredText = () => {
  return (
    <Badge p="1" mx="1" colorScheme="red" data-testid="expired-payment-method">
      <FormattedMessage defaultMessage="Expired" description="label" />
    </Badge>
  );
};

/**
 * Component for displaying payment method tags.
 * @param {Object} props - Component props.
 * @param {Object} props.paymentMethod - The payment method object.
 * @returns {JSX.Element} PaymentMethodTags component.
 */
const PaymentMethodTags = ({ paymentMethod }) => {
  // How default is determine is more than just tags
  // so we let the parent (usually the flow) handle if a payment method
  // is considered default.
  const isDefault = paymentMethod.isDefault;

  const isExpired = paymentMethod.tags?.find(
    (tag) => tag.tag === "expired" && tag.status === "ACTIVE"
  );

  // The reason for Fragment return is because the parent component
  // uses flexbox to place the elements below appropriately.
  return (
    <>
      {isDefault && <DefaultText />}
      {isExpired && <ExpiredText />}
    </>
  );
};

export default PaymentMethodTags;
